import { Icons } from '@silverfort/sf-components';
import { BlockPage } from '../../../routings/pages/BlockPage/BlockPage';
import mainImage from './mainImage.png';

export const CloudISPMBlockPage = () => {
    const topics = [
        <span>
            Gain visibility into your <span className="font-medium">cloud identity attack surface</span>, including
            users, resources, and permissions
        </span>,
        'Get actionable and automated recommendations to remediate identity issues',
        'Mitigate vulnerabilities by proactively hardening identity systems'
    ];
    return (
        <BlockPage
            leftContent={{ title: 'Identity Security Posture Management', image: mainImage }}
            rightContent={{
                title: 'Extend Your ISPM Capabilities to Cloud',
                icon: Icons.IdentitySearch,
                description:
                    'Investigate, prioritize, and resolve 200+ risk exposures in your Cloud infrastructure, applications, and more.',
                topics,
                accessLink: 'https://www.silverfort.com/cloud-ispm-signup/?utm_source=PQL&utm_content=main'
            }}
        />
    );
};
